// export const translateSport = {
//     "Corrida": "running",
//     "Natação": "swimming",
//     "Bicicleta": "bike",
//     "BFR": "running",
//     "Trail": "running",
//     "Nordic Walking": "running",
//     "Máquinas indoor": "indoor"
// }

const translateSport = (i18n) => (sport) => {
	switch (sport) {
		case 'Corrida':
			return 'running'
		case 'Natação':
			return 'swimming'
		case 'Bicicleta':
			return 'bike'
		case 'BFR':
			return 'running'
		case 'Trail':
			return 'running'
		case 'Nordic Walking':
			return 'running'
		case 'Máquinas indoor':
			return 'indoor'
		default:
			break
	}
}

const translateGround = (ground) => {
	switch (ground) {
		case 'Estrada':
			return 'estrada'
		case 'Montanha':
			return 'mountain'
		case 'Piscina':
			return 'pool'
		case 'Misto':
			return 'mixed'
		case 'Montanha W+':
			return 'mountain'
		default:
			break
	}
}

const translateType = (type) => {
	switch (type) {
		case 'Normal':
			return 'Normal'
		case 'Cumulate':
			return 'Acumulada'
		case 'Bidaily':
			return 'Bidiária'
		default:
			break
	}
}

class TranslationHelper {
	constructor(i18n) {
		this.i18n = i18n
		this.translateDay = this.translateDay.bind(this)
		this.translateMonth = this.translateMonth.bind(this)
	}

	translateMonth(month) {
		const i18n = this.i18n
		const monthDictionary = [i18n`janeiro_label`, i18n`fevereiro_label`, i18n`marco_label`, i18n`abril_label`, i18n`maio_label`, i18n`junho_label`, i18n`julho_label`, i18n`agosto_label`, i18n`setembro_label`, i18n`outubro_label`, i18n`novembro_label`, i18n`dezembro_label`]
		return monthDictionary[month]
	}

	translateDay(day) {
		const i18n = this.i18n
		const dayDictionary = [
			i18n`monday_label`,
			i18n`tuesday_label`,
			i18n`wednesday_label`,
			i18n`thursday_label`,
			i18n`friday_label`,
			i18n`saturday_label`,
			i18n`sunday_label`
		]
		return dayDictionary[day]
	}

}

export {
	translateSport,
	translateGround,
	translateType,
	TranslationHelper
}



// WEBPACK FOOTER //
// ./src/client/utils/translationHelpers.js